import {
    GET_REPORT_ON_SCREEN,
    GET_EXPORT_REPORT,
    GET_PDF_REPORT,
    GET_PDF_REPORT_COMMITTEE,
    GET_REPORT_OUTSTANDING_ON_SCREEN,
    GET_EXPORT_OUTSTANDING_REPORT

}
    from '../actions/actionTypes'

const initialState = {
    resultSearch: [],
    exportSearch: [],
    resultPDF: null,
    resultPDFCommittee: [],
    resultReportOutSearch: [],
    exportReportOutSearch: [],
}

function SearchRedux (state = initialState, action) {
    switch (action.type) {
        case GET_REPORT_ON_SCREEN:
            return {
                ...state,
                resultSearch: action.payload,
            }
        case GET_EXPORT_REPORT:
            return {
                ...state,
                resultExport: action.payload,
            }
        case GET_PDF_REPORT:
            return {
                ...state,
                resultPDF: action.payload,
            }
        case GET_PDF_REPORT_COMMITTEE:
            return {
                ...state,
                resultPDFCommittee: action.payload,
            }
        case GET_REPORT_OUTSTANDING_ON_SCREEN:
            return {
                ...state,
                resultReportOutSearch: action.payload,
            }
        case GET_EXPORT_OUTSTANDING_REPORT:
            return {
                ...state,
                exportReportOutSearch: action.payload,
            }
        default:

            return state
    }
}

export default SearchRedux